import React from "react";

const StorePage: React.FC = () => <p>hi</p>;

export default StorePage;
